import React, { FC, ReactNode, useEffect } from 'react';
import { DEFAULT_TITLE } from '../../consts';

type RouteTitleProps = {
  title: string;
  children: ReactNode;
};

const RouteTitle: FC<RouteTitleProps> = ({ title, children }) => {
  useEffect(() => {
    document.title = title;

    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);

  return <>{children}</>;
};

export default RouteTitle;
